import { ExternalLink } from "components/playground/links/ExternalLink";
import { createLinkOverride } from "components/playground/links/Link";
import { RelativeLink } from "components/playground/links/RelativeLink";
import { SandboxLink } from "components/playground/links/SandboxLink";
import { WalkthroughLink } from "components/playground/links/WalkthroughLink";
import { SandboxError } from "components/sandbox-router/SandboxError";
import { useNavigate } from "react-router-dom";
import { routeTo, SandboxNavigation } from "router";
import { useAppDispatch } from "store";
import { openFile, OpenFileAction } from "store/features";
import { toaster } from "@itwin/itwinui-react";
import { FocusMode, MarkdownOptions } from "@sandbox/code-editor";

interface Options {
  onStepChanged?: (annotationId: string) => void
}

export const useMarkdownOptions = ({ onStepChanged }: Options) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const options: MarkdownOptions = {
    options: {
      overrides: {
        a: createLinkOverride({
          linkTypes: [
            {
              filter: (href) => !/^https?:/gi.test(href) && /step/gi.test(href),
              component: WalkthroughLink,
              props: {
                onClick: (annotationId: string) => {
                  onStepChanged && onStepChanged(annotationId);
                },
              },
            },
            {
              filter: (href) => /^\/.+\/.+/gi.test(href),
              component: SandboxLink,
              props: {
                onClick: async (userName?: string, sandboxName?: string, fileName?: string, start?: number, end?: number) => {
                  if (userName && sandboxName) {
                    let args: SandboxNavigation = { userName, sandboxName, file: fileName };
                    if (start !== undefined) args.start = `${start}`;
                    if (end !== undefined) args.end = `${start}`;
                    navigate(routeTo.sandbox(args));
                  }
                },
                onError: (error: Error) => {
                  toaster.warning(error.message, { hasCloseButton: true });
                },
              },
            },
            {
              filter: (href) => /^\.\/[a-zA-Z0-9-_\.\/?&=]+$/gi.test(href),
              component: RelativeLink,
              props: {
                onClick: async (filePath: string, start?: number, end?: number, focusMode?: FocusMode) => {

                  const args: OpenFileAction = {
                    filePath,
                    focusMode
                  }

                  if (start) {
                    args.selection = {
                      startLineNumber: start,
                      endLineNumber: end ?? start,
                      startColumn: 0,
                      endColumn: Infinity
                    }
                  }

                  dispatch(openFile(args));
                },
                onError: (error: SandboxError) => {
                  toaster.warning(error.message, { hasCloseButton: true });
                },
              },
            },
            {
              filter: (href) => /^https?:/gi.test(href),
              component: ExternalLink,
              props: {},
            },
          ],
        }),
      },
    },
  }

  return options;
}